/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { apiClient } from './api'
import { handleError } from './error';
import { AppDispatch } from '../reducers';

export const reloadOnboardingToken = (token: string) => loadOnboardingToken(token, false);

export const loadOnboardingToken = (token: string, blockingLoad = true) => (dispatch: AppDispatch) => {

  if (blockingLoad) {
    dispatch({ type: actionTypes.LOADING_ONBOARDING_TOKEN });
  }

  return apiClient.get('direct/onboarding/token/' + token)
    .then(response => {
      dispatch({
        type: actionTypes.LOADED_ONBOARDING_TOKEN,
        data: response.data.data,
      });
    })
    .catch(handleError(dispatch, actionTypes.ERROR_ONBOARDING_TOKEN))
};

